// let  BASE_URL = 'http://localhost:1337';
// let  FrontEndURL = 'http://localhost:1337';
let  BASE_URL = 'https://dev-api.nisafinance.com';
let  FrontEndURL = 'https://dev-app.nisafinance.com';
let NISADOCLOCK_EXTENSION_ID = 'ggppajielldmegaafnodbplnjiefoohb';
let TENANT_ID = 'client-2'; // Default for local development

if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    BASE_URL = 'https://dev-api.nisafinance.com';
    FrontEndURL = 'https://dev-app.nisafinance.com';
    TENANT_ID = 'client-2';
} else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
    BASE_URL = 'https://dev-api.nisafinance.com';
    FrontEndURL = 'https://dev-app.nisafinance.com';
    TENANT_ID = 'client-2';
} else if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    BASE_URL = 'https://mmf-dev-api.nisafinance.com';
    FrontEndURL = 'https://mmf-dev.nisafinance.com';
    TENANT_ID = 'client-1'; // MMF production uses client-3
} else if (process.env.REACT_APP_ENVIRONMENT === 'nisa-production') {
    // NISA Production Environment
    BASE_URL = 'https://api.nisafinance.com';
    FrontEndURL = 'https://app.nisafinance.com';
    TENANT_ID = 'client-3'; // NISA production uses client-3
} else {
    BASE_URL = 'https://mmf-dev-api.nisafinance.com';
    FrontEndURL = 'https://mmf-dev.nisafinance.com';
    TENANT_ID = 'client-1';
}
const BANK_API_URL = 'https://mmf-scraper.nisafinance.com';
const config = {
    BASE_URL,
    API_URL: BASE_URL, // Alias for consistency
    FrontEndURL,
    BANK_API_URL,
    NISADOCLOCK_EXTENSION_ID,
    TENANT_ID,
    devMode: false,
    // Use Mock Services
    devModeServiceDelay: 3000,
     // How long the service should take
    BASE_URL_PREFIX: '',
    BASE_URL_AUTH: '/auth',
    FORGOT_PASSWORD_URL: '/auth/reset-password',
    ENABLE_MULTI_SIGNER: true
};

export default config;





// let  BASE_URL = 'https://dev-api.nisafinance.com';
// let  FrontEndURL = 'https://app.nisafinance.com';
// let NISADOCLOCK_EXTENSION_ID = 'ggppajielldmegaafnodbplnjiefoohb';
// if (process.env.REACT_APP_ENVIRONMENT === 'development') {
//     BASE_URL = 'http://54.234.102.45:1337';
//     BASE_URL = 'http://54.234.102.45:1337';
//     FrontEndURL = 'https://app.nisafinance.com';
// } else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
//     BASE_URL = 'https://dev-api.nisafinance.com';
//     FrontEndURL = 'https://app.nisafinance.com';
// } else if (process.env.REACT_APP_ENVIRONMENT === 'production') {
//     BASE_URL = 'https://mmf-dev-api.nisafinance.com';
//     BASE_URL = 'https://mmf-dev-api.nisafinance.com';
//     FrontEndURL = 'https://mmf-dev.nisafinance.com';
// } else{
//     BASE_URL = 'https://mmf-dev-api.nisafinance.com';
//     BASE_URL = 'https://mmf-dev-api.nisafinance.com';
//     FrontEndURL = 'https://mmf-dev.nisafinance.com';
// }
// const BANK_API_URL = 'https://mmf-scraper.nisafinance.com';
// const config = {
//     BASE_URL,
//     FrontEndURL,
//     BANK_API_URL,
//     NISADOCLOCK_EXTENSION_ID,
//     devMode: false,
//     // Use Mock Services
//     devModeServiceDelay: 3000,
//      // How long the service should take
//     BASE_URL_PREFIX: '',
//     BASE_URL_AUTH: '/auth',
//     FORGOT_PASSWORD_URL: '/auth/reset-password',
//     ENABLE_MULTI_SIGNER: true
// };

// export default config;